/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'circle-alert': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#E5092B" d="M8 1.6c3.535 0 6.4 2.865 6.4 6.4s-2.865 6.4-6.4 6.4S1.6 11.535 1.6 8 4.465 1.6 8 1.6zm0 .8a5.6 5.6 0 100 11.2A5.6 5.6 0 008 2.4zm.007 7.867a.4.4 0 01.072.793l-.072.007a.4.4 0 01-.079-.794l.079-.006zM8 4.933c.196 0 .36.142.394.328l.006.072V8a.401.401 0 01-.794.072L7.6 8V5.333c0-.22.18-.4.4-.4z"/>'
  }
})
